import { buildApiUrl } from "../../../config.js";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaEdit, FaTimes } from "react-icons/fa";

const EditModal = ({ category, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    itemCode: "",
    categoryName: "",
    itemName: "",
    unit: "",
    pcsPerCtn: "",
    wtPerCtn: "",
    cbmPerCtn: "",
  });

  useEffect(() => {
    if (category) {
      setFormData({
        itemCode: category.itemCode || "",
        categoryName: category.categoryName || "",
        itemName: category.itemName || "",
        unit: category.unit || "",
        pcsPerCtn: category.pcsPerCtn || "",
        wtPerCtn: category.wtPerCtn || "",
        cbmPerCtn: category.cbmPerCtn || "",
      });
    }
  }, [category]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        buildApiUrl(`/api/categories/${category._id}`),
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const updatedCategory = await response.json();
        onUpdate(updatedCategory);
        toast.success("Category updated successfully!");
        onClose();
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to update category.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the category.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50 transition-opacity duration-300">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto mx-4 p-4 transform transition-all duration-300 scale-100">
        <div className="flex items-center justify-between border-b border-gray-200 pb-2">
          <div className="flex items-center gap-2">
            <FaEdit className="text-indigo-600" size={16} />
            <h2 className="text-lg font-semibold text-gray-800">Edit Item</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FaTimes size={16} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-3 space-y-3">
          <div>
            <label
              htmlFor="itemCode"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Item Code
            </label>
            <input
              id="itemCode"
              type="text"
              name="itemCode"
              value={formData.itemCode}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              required
            />
          </div>

          <div>
            <label
              htmlFor="categoryName"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Category Name
            </label>
            <input
              id="categoryName"
              type="text"
              name="categoryName"
              value={formData.categoryName}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              required
            />
          </div>

          <div>
            <label
              htmlFor="itemName"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Item Name
            </label>
            <input
              id="itemName"
              type="text"
              name="itemName"
              value={formData.itemName}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              required
            />
          </div>

          <div>
            <label
              htmlFor="unit"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Unit
            </label>
            <input
              id="unit"
              type="text"
              name="unit"
              value={formData.unit}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="pcsPerCtn"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Qty/Ctn
            </label>
            <input
              id="pcsPerCtn"
              type="number"
              name="pcsPerCtn"
              value={formData.pcsPerCtn}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="wtPerCtn"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Wt/Ctn
            </label>
            <input
              id="wtPerCtn"
              type="number"
              name="wtPerCtn"
              value={formData.wtPerCtn}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="cbmPerCtn"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              CBM/Ctn
            </label>
            <input
              id="cbmPerCtn"
              type="number"
              name="cbmPerCtn"
              value={formData.cbmPerCtn}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div className="flex justify-end items-center pt-3 border-t border-gray-200 gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-2 bg-gray-200 text-gray-700 text-xs rounded-md hover:bg-gray-300 transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-3 py-2 bg-indigo-600 text-white text-xs rounded-md hover:bg-indigo-800 transition-colors duration-200 flex items-center gap-1"
            >
              <FaEdit size={12} />
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(EditModal);
